<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else :key="'comments' + key">
            <div v-if="creating">
                <history-element-create
                    :default-comment-type="defaultCommentType"
                />
            </div>

            <div v-else>
                <comment-handler
                    v-for="item in items"
                    :key="'ch' + item.id"
                    :comment="item"
                />
                <b-alert :show="noComment" variant="secondary">
                    Aucun commentaire n'a été saisi
                </b-alert>
                <b-button
                    v-if="showCreate"
                    variant="primary"
                    size="sm"
                    @click="goToCreate"
                >
                    <i class="far fa-plus fa-fw"></i
                    ><span class="ml-1">Ajouter un commentaire</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '../../../../common/components/loading'
import HistoryElementShow from './Show'
import HistoryElementCreate from './Create'
import CommentHandler from '../../../activity/components/CommentHandler'

export default {
    name: 'HistoryIndex',

    components: {
        loading,
        HistoryElementShow,
        HistoryElementCreate,
        CommentHandler,
    },

    props: {
        company: null,
    },

    data() {
        return {
            items: [],
        }
    },

    async created() {
        this.$store.commit('browsing/RESET_CREATING')
        this.$store.commit('browsing/RESET_EDITING')
        this.$store.commit('browsing/SET_PAGE_NAME', 'history.index')
        this.$store.commit('browsing/SET_CLIENT_ID', this.company.id)
        await this.getItems()
    },

    methods: {
        goToCreate() {
            this.$store.commit('browsing/SET_CREATING')
        },

        async getItems() {
            try {
                this.$store.commit('browsing/START_LOADING')
                const response = await axios.get(
                    `/clients/${this.company.id}/history`
                )
                this.items = response.data.data
                this.$store.commit('browsing/STOP_LOADING')
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            creating: (state) => state.browsing.creating,
            loading: (state) => state.browsing.loading,
            key: (state) => state.browsing.key,
            page: (state) => state.browsing.pageName,
        }),

        showCreate() {
            return !this.creating
        },

        noComment() {
            return this.items.length === 0
        },

        routeName() {
            return this.$route ? this.$route.name : null
        },

        defaultCommentType() {
            return this.routeName === 'prospect-history' ? 'crm' : null
        },
    },
}
</script>

<style scoped></style>
